import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { publicAPI } from '../../services/api';
import './BrandProducts.css';

const BrandProducts = () => {
  const { brandId } = useParams();
  const [products, setProducts] = useState([]);
  const [brandName, setBrandName] = useState('');
  const [loading, setLoading] = useState(true);
  const [heroStyle, setHeroStyle] = useState({ background: 'rgb(116, 70, 49)', color: 'white' });

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        // 1. Cargar productos filtrados por la marca
        const productsRes = await publicAPI.getProducts(brandId);
        setProducts(productsRes.data);

        // Cargar configuración de estilos
        const heroImageRes = await publicAPI.getHeroImage();
        if (heroImageRes.data) {
           const { file_path, type } = heroImageRes.data;
           if (type === 'image') {
              setHeroStyle({ background: `url(${file_path}) center/cover no-repeat`, color: 'rgb(116, 70, 49)' });
           } else if (type === 'color') {
              setHeroStyle({ background: file_path, color: 'white' });
           }
        } else { // Si no hay imagen activa, usar el color por defecto
          setHeroStyle({ background: 'rgb(116, 70, 49)', color: 'white' });
        }

        // 2. Cargar el nombre de la marca para el título
        const brandsRes = await publicAPI.getBrands();
        const brand = brandsRes.data.find(b => b.id === parseInt(brandId));
        if (brand) {
          setBrandName(brand.name);
        }
      } catch (error) {
        console.error('Error cargando datos:', error);
      } finally {
        setLoading(false);
      }
    };

    if (brandId) {
      loadData();
    }
  }, [brandId]);

  if (loading) return <div className="loading">Cargando productos...</div>;

  return (
    <div className="brand-products-page" style={{ color: 'rgb(116, 70, 49)' }}>
      <div className="container">
        <div className="navigation-header">
          <Link to="/marcas" className="back-btn">← Volver a Marcas</Link>
        </div>
        
        <section className="hero-section" style={{ ...heroStyle, padding: '3rem 0', marginBottom: '3rem', textAlign: 'center' }}>
          <h1>Productos {brandName}</h1>
        </section>
        
        {products.length === 0 ? (
          <div className="no-products">
            <p>No hay productos disponibles para esta marca en este momento.</p>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-image-container">
                  {product.image_path ? (
                    <img 
                      src={product.image_path} 
                      alt={product.name} 
                      className="product-image" 
                    />
                  ) : (
                    <div className="no-image-placeholder">Sin Imagen</div>
                  )}
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandProducts;
